import { useMemo } from "react";
import { bool, number, object } from "prop-types";
import { roundFloat } from "@repo/utils";
import { observer } from "mobx-react";
import { useDraggable } from "@dnd-kit/react";
import { useEstimateStructure, useEstimateEditorSettings, useTimelineBarChartWidth } from "@tools";
import { Tooltip } from "@material-ui/core";
import { TimelineSectionBarTooltip } from "./TimelineSectionBarTooltipContent";
import useStyle from "./TimelineSectionBar.style"
import classnames from "classnames";

export const TimelineSectionBar =  observer(({
  index,
  section,
  isDraggable,
  isPlaceholder,
}) => {
  const classes = useStyle();
  
  const structure = useEstimateStructure();
  const { allowEdition } = useEstimateEditorSettings();
  const { workTypes, settings } = structure;
  const { modifier, usedRoundHours, usedRoundDecimals } = settings;
  
  const {
    id,
    name,
    timelineStartWeek,
    timelineStartMonth,
    timelineEndWeek,
    timelineEndMonth,
    workTypes: sectionWorkTypes,
    taskWorkTypes,
    taskValues,
  } = section;
  
  const { ref } = useDraggable({
    id,
    index,
    disabled: !allowEdition,
    attributes: {
      tabIndex: index,
      role: "timeline section"
    }
  });
  
  const tooltipValues = useMemo(() => (
    workTypes
      .filter(wT => (
        // sectionWorkTypes.find(wT => wT.id === wT.id) && !wT.areHoursOverwritten
        sectionWorkTypes.find(wT => wT.id === wT.id) && !wT.hasFixedHours
      ))
      .map(wT => ({
        name:  wT.name,
        hours: roundFloat((section.getTotalHoursPerWorkType(wT.id)?.[section.timelineWorkTypeHoursKey(wT.id)] || 0) / modifier, usedRoundHours, false, usedRoundDecimals)
      }))
  ), [workTypes, sectionWorkTypes, taskWorkTypes, taskValues, modifier, usedRoundHours, usedRoundDecimals]);
  
  const { width, offsetLeft, offsetRight, exceeds } = useTimelineBarChartWidth({
    isDraggable,
    startWeek: timelineStartWeek,
    startMonth: timelineStartMonth,
    endWeek: timelineEndWeek,
    endMonth: timelineEndMonth,
  })
  
  return (
    <div
      ref={ref}
      style={{
        width,
        paddingLeft: offsetLeft || undefined,
        paddingRight: offsetRight || undefined,
      }}
      className={classnames(classes.container, isPlaceholder && "semi-transparent", exceeds && !isPlaceholder && classes.containerExceeds)}
    >
      <Tooltip
        placement="top"
        title={(
          <TimelineSectionBarTooltip
            name={name}
            values={tooltipValues}
          />
        )}
      >
        <div className={classnames(classes.block, exceeds && !isPlaceholder && classes.exceeds)}>
          {name}
        </div>
      </Tooltip>
    </div>
  );
});

TimelineSectionBar.propTypes = {
  index: number.isRequired,
  section: object.isRequired,
  isDraggable: bool,
  isPlaceholder: bool,
};